import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect, createContext, useContext } from 'react';
import { userStore } from '../store/module/userStore';
import { message } from 'antd';
import LoginApi from "../services/userAuth";
const AuthContext = createContext(undefined);
export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [userInfo, setUserInfo] = useState(null);
    const [messageApi] = message.useMessage();
    useEffect(() => {
        // 初始化认证状态
        const userData = localStorage.getItem('userInfo');
        if (userData) {
            setUserInfo(JSON.parse(userData));
            setIsAuthenticated(true);
        }
        setLoading(false);
    }, []);
    const login = async (account, password) => {
        var _a;
        try {
            const res = await LoginApi.Login({ account, password }).catch((err) => {
                messageApi.error('登录失败，请稍后重试');
                return null;
            });
            if (!res)
                return false;
            if (res.code !== undefined) {
                const result = res;
                if (result.code === 0) {
                    userStore.setUserInfo(result.data);
                    setUserInfo(result.data);
                    setIsAuthenticated(true);
                    return true;
                }
                messageApi.error(result.msg || '登录失败，请稍后重试');
                return false;
            }
            const data = (_a = res.data) !== null && _a !== void 0 ? _a : res;
            userStore.setUserInfo(data);
            setUserInfo(data);
            setIsAuthenticated(true);
            return true;
        }
        catch (error) {
            console.error('Login error:', error);
            return false;
        }
    };
    const logout = () => {
        localStorage.removeItem('userInfo');
        userStore.userInfo = null;
        setUserInfo(null);
        setIsAuthenticated(false);
    };
    return (_jsx(AuthContext.Provider, { value: { isAuthenticated, loading, userInfo, login, logout }, children: children }));
};
export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return ctx;
};
